<template>
  <div data-v-46e20943="" data-v-2ac6a5fc="" class="news-details-page">
    <div data-v-46e20943="" class="news-details-container">
      <div data-v-46e20943="" class="news-title-wrapper" style="display: none;">
        <p data-v-46e20943="" class="title" style="color: #000">{{ dataInfo.title }}</p>
        <p data-v-46e20943="" class="time">{{ dataInfo.created_at }}</p>
      </div>
      <p data-v-46e20943="" class="news-content" v-html="dataInfo.content"></p>
      <p data-v-46e20943="" class="news-content" v-html="dataInfo.memo"></p>
      <div
        @click="$parent.openKefu()"
        style="margin: 50px auto; display: block; cursor: pointer; width: 50%; height: 45px; line-height: 45px; font-size: 16px; background: linear-gradient(224deg, #ffdf91, #ffcb4c); border-radius: 4px; color: #482000; text-align: center; font-weight: 700; margin-top: 40px"
      >
        点我申请
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'activeInfo',
  data () {
    return { dataInfo: {} };
  },
  created () {
    let that = this;
    var query = that.$route.query;
    if (query.id) {
      that.getInfo(query.id);
    }
  },
  methods: {
    getInfo (id) {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/activitydeatil', { id }).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.dataInfo = res.data;
        }
        that.$parent.hideLoading();
      });
    },
    doactivityapply () {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun.post('/api/doactivityapply', { activityid: that.dataInfo.id }).then(res => {
        that.$parent.showTost(1, res.message);
        that.$parent.hideLoading();
      });
    },
  },
  mounted () {
    let that = this;
  },
  updated () {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/chunk-3f7bf009.c75e1438.css';
.news-details-page[data-v-46e20943][data-v-7c66dfec] {
  left: -1px;

  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/main/activeInfo.vue